import { Container, Row } from 'react-bootstrap';
import SideBar from '../components/SideBar';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SubPage = ({
  title,
  parent_link,
  side_list,
  isOnePage,
  background_info,
  side_scroll_color = { bg_color: '#2d75d1', color: 'white' },
}) => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0); //pathname이 바뀌는 경우, 스크롤을 맨 위로 올려줌
  }, [pathname]);

  const [isSubMenuAttached, setIsSubMenuAttached] = useState(false);
  useEffect(() => {
    //scroll 이벤트를 담당하는 eventListener 장착
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll); //clean up
    };
  }, []);
  const handleScroll = () => {
    // console.log(window.scrollY)
    if (window.scrollY > 269) {
      // console.log('state변경');
      setIsSubMenuAttached(true);
      return;
    }
    // console.log('state변경');
    setIsSubMenuAttached(false);
    return;
  };
  return (
    //bg img는 public에 두고, 그냥 /{filename}으로 사용하면 된다.
    <div>
      <Row>
        {background_info && (
          <Container
            className={`text-center col-12${
              isSubMenuAttached ? '' : 'sub-menu'
            }`}
            style={{
              height: '20rem',
              backgroundImage: `${
                background_info !== undefined && background_info.link
                  ? `url(${background_info.link})`
                  : ''
              }`,
              backgroundSize: 'cover',
            }}
          >
            {/* <h1
            style={{ fontWeight: 'bold' }}
            className={`${
              isSubMenuAttached ? 'sticky-sub-menu shadow-sm text-start' : ''
            }`}
          >
            {title}
          </h1> */}
            <h2
              style={{ lineHeight: '20rem', color: 'white', fontWeight: '600' }}
            >
              {background_info ? background_info.text : 'text없음'}
            </h2>
          </Container>
        )}
      </Row>
      <Row>
        <Container className="col-2">
          <SideBar
            title={title}
            parent_link={parent_link}
            side_list={side_list}
            isSubMenuAttached={isSubMenuAttached || !background_info}
            isOnePage={isOnePage}
            side_scroll_color={side_scroll_color}
          />
        </Container>
      </Row>
    </div>
  );
};
export default SubPage;
